import { gql } from '@apollo/client'

export const updateSign = gql`
mutation MyMutation(
    $id:String
    $name:String
    $instSign:String
    $examSign:String
    $instapproval:String
    $examapproval:String
    $instvalid:date
    $examvalid:date

) {
    update_aatmsv4_simulatorinst(where: {usersid: {_eq: $id}}, 
      _set: {
        instructorsign: $instSign, 
        examinersign: $examSign,
        instvalidity: $instvalid,
        examvalidity: $examvalid,
        instructorapproval: $instapproval,
        examinerapproval: $examapproval
      }) {
      returning {
        name
      }
    }
  }
  
 `

export const getSign = gql`
query MyQuery($id: String) {
  aatmsv4_simulatorinst(where: {usersid: {_eq: $id}}) {
    name
    instructorsign
    examinersign
    instructorapproval
    instvalidity
    examinerapproval
    examvalidity
  }
}
`
